import React from 'react';
import { Box } from '@mui/material';
import MusicNoteIcon from '@mui/icons-material/MusicNote';
import './MusicLoader.scss';

const MusicLoader = () => {
  return (
    <Box className="music-loader-container">
      {/* Animated Music Notes */}
      <div className="music-notes-wrapper">
        <MusicNoteIcon className="music-note note1" />
        <MusicNoteIcon className="music-note note2" />
        <MusicNoteIcon className="music-note note3" />
        <MusicNoteIcon className="music-note note4" />
        <MusicNoteIcon className="music-note note5" />
      </div>

      {/* Sound Wave Bars */}
      <div className="sound-wave">
        <span className="bar bar1"></span>
        <span className="bar bar2"></span>
        <span className="bar bar3"></span>
        <span className="bar bar4"></span>
        <span className="bar bar5"></span>
        <span className="bar bar6"></span>
        <span className="bar bar7"></span>
      </div>
    </Box>
  );
};

export default MusicLoader;
